<dz-microaction *ngIf="tourDialogContent.length" [icon]="iconType" (click)="openTakeATourDialog()">
	<span class="text-16-bold" [dcrHTMLKey]="dcrPrefix + '_LINK'">Take a tour</span>
</dz-microaction>
